module.exports = __webpack_public_path__ + "img/99.a629977.png";